import React from 'react';
import { motion } from 'framer-motion';
import { Plus, Check, Sparkles } from 'lucide-react';
function IncludeItem({
  children,
  bold
}: {
  children: React.ReactNode;
  bold?: boolean;
}) {
  return <li className="flex items-start gap-3" data-id="element-105">
      <Plus className="text-brand-600 shrink-0 mt-0.5" size={18} data-id="element-106" />
      <span className={bold ? 'text-gray-900 font-medium' : 'text-gray-700'} data-id="element-107">
        {children}
      </span>
    </li>;
}
export function PricingSection() {
  return <section className="py-24 px-6 bg-gray-50" data-id="element-108">
      <div className="max-w-6xl mx-auto" data-id="element-109">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-110">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-gray-900 mb-4" data-id="element-111">
            Planes transparentes
          </h2>
          <p className="text-lg text-gray-500 max-w-2xl mx-auto" data-id="element-112">
            Elige si quieres hacerlo todo tú… o dejar de perder tiempo con leads
            que no sirven
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch" data-id="element-113">
          {/* Plan Básico */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0
        }} className="bg-white rounded-3xl p-8 border border-gray-200 shadow-sm flex flex-col" data-id="element-114">
            <div className="mb-6" data-id="element-115">
              <p className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-1" data-id="element-116">
                Plan Básico
              </p>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-117">
                Todo para publicar bien
              </h3>
              <div className="flex items-baseline gap-1 mb-1" data-id="element-118">
                <span className="text-4xl font-extrabold tracking-tight text-gray-900" data-id="element-119">
                  $129.900
                </span>
              </div>
              <p className="text-xs text-gray-400 mb-3" data-id="element-120">
                6 meses + 3 meses extra gratis si no vendes
              </p>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-121">
                Acceso completo al sistema para vender tu propiedad por tu
                cuenta
              </p>
            </div>

            <ul className="space-y-3 mb-8 text-sm flex-1" data-id="element-122">
              <IncludeItem data-id="element-123">Acceso completo al sistema</IncludeItem>
              <IncludeItem data-id="element-124">
                Programa paso a paso para vender tu propiedad (videos + guía)
              </IncludeItem>
              <IncludeItem data-id="element-125">
                Pricing inteligente (rango + recomendado)
              </IncludeItem>
              <IncludeItem data-id="element-126">Simulación precio vs tiempo de venta</IncludeItem>
              <IncludeItem data-id="element-127">Generador de publicación con IA</IncludeItem>
              <IncludeItem data-id="element-128">
                Estructura profesional (título + formato)
              </IncludeItem>
              <IncludeItem data-id="element-129">Guía para tomar buenas fotos</IncludeItem>
              <IncludeItem data-id="element-130">Mejora automática de imágenes</IncludeItem>
            </ul>

            <button className="w-full py-3 px-6 rounded-xl font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 transition-colors text-sm mt-auto" data-id="element-131">
              Elegir Plan Básico
            </button>
          </motion.div>

          {/* Plan Pro */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white rounded-3xl p-8 border-2 border-brand-600 shadow-xl relative flex flex-col" data-id="element-132">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-brand-600 text-white px-4 py-1 rounded-full text-sm font-bold flex items-center gap-1.5 shadow-sm whitespace-nowrap" data-id="element-133">
              <Sparkles size={14} data-id="element-134" />
              Más elegido
            </div>

            <div className="mb-6" data-id="element-135">
              <p className="text-sm font-semibold text-brand-600 uppercase tracking-wider mb-1" data-id="element-136">
                Plan Pro
              </p>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-137">
                Publica y filtra sin esfuerzo
              </h3>
              <div className="flex items-baseline gap-1 mb-1" data-id="element-138">
                <span className="text-4xl font-extrabold tracking-tight text-gray-900" data-id="element-139">
                  $349.900
                </span>
              </div>
              <p className="text-xs text-brand-500 mb-3" data-id="element-140">
                6 meses + 3 meses extra gratis si no vendes
              </p>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-141">
                Publicamos por ti y filtramos los contactos que no sirven
              </p>
            </div>

            <ul className="space-y-3 mb-8 text-sm flex-1" data-id="element-142">
              <li className="flex items-start gap-3 bg-brand-50 rounded-lg px-3 py-2 -mx-1" data-id="element-143">
                <Plus className="text-brand-600 shrink-0 mt-0.5" size={18} data-id="element-144" />
                <span className="text-brand-800 font-semibold text-sm" data-id="element-145">
                  Todo lo del Plan Básico, más:
                </span>
              </li>
              <IncludeItem data-id="element-146">Publicación en portales inmobiliarios</IncludeItem>
              <IncludeItem data-id="element-147">Gestión activa de la publicación</IncludeItem>
              <IncludeItem data-id="element-148">Inbox centralizado de contactos</IncludeItem>
              <IncludeItem data-id="element-149">
                Respuestas automáticas (WhatsApp y portales)
              </IncludeItem>
              <IncludeItem data-id="element-150">
                Clasificación automática de leads con IA
              </IncludeItem>
              <IncludeItem data-id="element-151">Filtro automático de corredores</IncludeItem>
              <IncludeItem data-id="element-152">Historial de conversaciones</IncludeItem>
              <IncludeItem data-id="element-153">Agenda automática de visitas</IncludeItem>
              <IncludeItem data-id="element-154">
                Confirmaciones y recordatorios automáticos
              </IncludeItem>
            </ul>

            <button className="w-full py-3.5 px-6 rounded-xl font-medium text-white bg-brand-600 hover:bg-brand-700 transition-colors shadow-sm hover:shadow-md text-sm mt-auto" data-id="element-155">
              Empezar con Plan Pro
            </button>
          </motion.div>

          {/* Plan Max */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white rounded-3xl p-8 border border-gray-200 shadow-sm flex flex-col" data-id="element-156">
            <div className="mb-6" data-id="element-157">
              <p className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-1" data-id="element-158">
                Plan Max
              </p>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-159">
                Negocia y cierra con respaldo
              </h3>
              <div className="flex items-baseline gap-1 mb-1" data-id="element-160">
                <span className="text-4xl font-extrabold tracking-tight text-gray-900" data-id="element-161">
                  $899.900
                </span>
              </div>
              <p className="text-xs text-gray-400 mb-3" data-id="element-162">
                6 meses + 3 meses extra gratis si no vendes
              </p>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-163">
                Todo el proceso cubierto: desde la publicación hasta el cierre
                legal
              </p>
            </div>

            <ul className="space-y-3 mb-8 text-sm flex-1" data-id="element-164">
              <IncludeItem bold data-id="element-165">Todo lo del Plan Pro, más:</IncludeItem>
              <IncludeItem data-id="element-166">
                Pipeline de venta (seguimiento por etapas)
              </IncludeItem>
              <IncludeItem data-id="element-167">Gestión completa de ofertas</IncludeItem>
              <IncludeItem data-id="element-168">Comparación de ofertas</IncludeItem>
              <IncludeItem data-id="element-169">Recomendaciones de negociación con IA</IncludeItem>
              <IncludeItem data-id="element-170">Scripts para responder y cerrar</IncludeItem>
              <IncludeItem data-id="element-171">Guía legal completa paso a paso</IncludeItem>
            </ul>

            <button className="w-full py-3 px-6 rounded-xl font-medium text-brand-700 bg-brand-50 hover:bg-brand-100 transition-colors text-sm mt-auto" data-id="element-172">
              Elegir Plan Max
            </button>
          </motion.div>
        </div>

        {/* Global note */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center text-sm text-gray-400 mt-10 max-w-xl mx-auto" data-id="element-173">
          Todos los planes incluyen 6 meses de acceso + 3 meses extra gratis si
          no vendes. Tú mantienes el control total en todo momento.
        </motion.p>
      </div>
    </section>;
}